import React from "react";
import "./StocksInNewsSlider.scss";
import OwlCarousel from "react-owl-carousel2";
import {MDBIcon} from "mdbreact";
import {assetUrl, loss_color, profit_color} from "../../serviceApi";
import {Link} from "react-router-dom";
import StockChart from "../StockChart";
import StockGraph from "../StockGraph/StockGraph";
import SparklineGraph from "../StockGraph/SparklineGraph";

const ProfilePic = assetUrl+"images/profile-icon.svg";

function StocksInNewsSlider(props) {
	const {stock_data} = props;
	const option = {
		items: stock_data.length > 1 ? 2 : 1,
		dots: false,
		rewind: false,
		autoplay: false,
		freeDrag: true,
		stagePadding: 1
	}

	return (
		<div className={"stocks-in-news-slider-component"}>
			{
				stock_data.length > 0 ?
					<OwlCarousel option={option}>
						{
							stock_data.map((item, index) => {
								let xaxis = [];
								let yaxis = [];
								let graphData = item.node.stockhistory ? item.node.stockhistory.edges : [];
								if (graphData.length === 1) {
									// let temp_xAxis = [graphData[0].node.updatedPrice]
									// xaxis = temp_xAxis.flatMap(i=>[i,i,i,i,i])
									// let temp_yAxis = [graphData[0].node.created]
									// yaxis = temp_yAxis.flatMap(i=>[i,i,i,i,i])
									var nowHour = new Date(graphData[0].node.created).getHours();
									var startDate = new Date(graphData[0].node.created);
									startDate.setDate(startDate.getDate() - 1);
									for (var i = 0; i < nowHour; i++) {
										let date = new Date(new Date(graphData[0].node.created).getTime() - (1000 * 60 * (60 * i)));
										if (date.getDate() > startDate.getDate()) {
											xaxis.push(date);
											yaxis.push(graphData[0].node.updatedPrice);
										}
									}

								} else {
									for (var i = 0; i < graphData.length; i++) {

										yaxis[i] = graphData[i].node.updatedPrice;
										xaxis[i] = graphData[i].node.created;
									}
								}

								return (
									<div className={"stock-card"} key={index}>
										<Link to={"/stock-detail/" + item.node.id}>
											<div className={"header"}>
												<div className={"d-flex align-items-center"}>
													<div className={"politician-profile"}>
														<img alt={'alt'} src={item.node.politicianImage?item.node.politicianImage:ProfilePic}
														     className={"trending-avatar"} width={"100%"}/>
													</div>
													<p className={"stock-name"}>
														{item.node.name}
													</p>
												</div>
												{/*stockOwned change*/}
												{/*<div className={"d-flex align-items-center"}*/}
												{/*     style={{*/}
												{/*	     marginTop: "13px",*/}
												{/*	     visibility: item.node.stockOwnedCount > 0 ? "visible" : "hidden"*/}
												{/*     }}>*/}
												{/*	<p className={"stock-count"}>{item.node.stockOwnedCount}</p>*/}
												{/*	<p className={"stock-text"}>Shares owned</p>*/}
												{/*</div>*/}
												<p className={"stock-price"}>₹ {item.node.price}</p>
												<div className={"d-flex align-items-center"}
												     style={{marginBottom: "8px"}}>
													{
														item.node.priceDiff > 0 ?
															<MDBIcon icon="caret-up" style={{color: profit_color}}/> :
															<MDBIcon icon="caret-down" style={{color: loss_color}}/>

													}
													<p className={"stock-diff-value"}
													   style={{color: item.node.priceDiff > 0 ? profit_color : loss_color}}
													>
														{item.node.priceDiff}%
													</p>
												</div>
											</div>
										</Link>
										{
											xaxis.length > 0 &&
											<SparklineGraph
												curve={"smooth"}
												sparkline={true}
												color={item.node.priceDiff > 0 ? profit_color : loss_color}
												xaxis={xaxis}
												yaxis={yaxis}
												graph_filter={"1day"}
												graph_loading={false}
											/>
										}

									</div>
								);
							})
						}
					</OwlCarousel>
					: <div className={"error-section"}>No Datas Found</div>

			}
		</div>
	);
}

export default StocksInNewsSlider;
